import { curveStepAfter } from 'd3-shape';
import '@d3fc/d3fc-element';
import { AnySelection, seriesSvgLine } from '@d3fc/d3fc-series';
import { deriveAverageExecutionPrice } from 'widgets/fillsGraph/fillsGraphData';
import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';

export const averageExecutionLine = () => {
    return seriesSvgLine()
        .crossValue(deriveTime)
        .mainValue(deriveAverageExecutionPrice)
        .curve(curveStepAfter)
        .decorate((s: AnySelection) => s.classed('avgExecLine', true));
};
